// src/components/layout/MainLayout.js
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopNavBar } from './TopNavBar';
import { useAuth } from '../../context/AuthContext';
import { ChangePasswordModal } from '../ChangePasswordModal';

export const MainLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  
  const { userProfile } = useAuth(); 

  // --- Lógica para manter Sidebar aberta no Desktop para Gerenciador/SOE ---
  useEffect(() => {
    // Adicionado 'soe' à verificação
    if (userProfile?.nivel === 'gerenciador' || userProfile?.nivel === 'soe') {
        // Verifica se a largura da janela é maior que 1024px (padrão desktop lg do Tailwind)
        if (window.innerWidth >= 1024) {
            setIsSidebarOpen(true);
        }
    }
  }, [userProfile]); // Executa quando o perfil do usuário é carregado

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="bg-gray-100 min-h-screen">
      
      <TopNavBar 
        onToggleSidebar={toggleSidebar} 
        onOpenChangePassword={() => setShowChangePasswordModal(true)}
      />
      
      <Sidebar 
        isSidebarOpen={isSidebarOpen} 
        toggleSidebar={toggleSidebar}
      />
      
      {/* Conteúdo Principal com margem dinâmica baseada na sidebar */}
      <main className={`p-4 transition-all duration-300 ${isSidebarOpen ? 'sm:ml-64' : 'sm:ml-0'}`}>
        
        <div className="mt-20"> 
          <Outlet />
        </div>
      </main>
      
      <ChangePasswordModal 
        show={showChangePasswordModal}
        onClose={() => setShowChangePasswordModal(false)}
        userProfile={userProfile}
      />

    </div>
  );
};